<script setup lang="ts">
import { computed } from 'vue';

import { AppSvgIcon } from '@libs/ui';
import type { AppSvgIconType } from '@libs/ui';

import {
  ItinerarySegmentType,
  isItineraryLocationSegmentType,
} from '../../models';

interface ItineraryIconProps {
  segmentType: ItinerarySegmentType;
}

const props = defineProps<ItineraryIconProps>();

const iconSize = computed(() =>
  isItineraryLocationSegmentType(props.segmentType) ? '24' : '18'
);

const iconName: Record<ItinerarySegmentType, AppSvgIconType> = {
  [ItinerarySegmentType.StartLocation]: 'nearMe',
  [ItinerarySegmentType.EndLocation]: 'nearMe',
  [ItinerarySegmentType.MiddleLocation]: 'locationMark',
  [ItinerarySegmentType.Accommodation]: 'bed',
  [ItinerarySegmentType.OwnStay]: 'bedOutlinedCrossed',
  [ItinerarySegmentType.Activity]: 'activity',
  [ItinerarySegmentType.Ferry]: 'ferry',
  [ItinerarySegmentType.Flight]: 'airplane',
  [ItinerarySegmentType.Car]: 'car',
  [ItinerarySegmentType.Walk]: 'personWalking',
  [ItinerarySegmentType.Cycle]: 'personBicycling',
  [ItinerarySegmentType.NoTransport]: 'noTransport',
  [ItinerarySegmentType.UpsellNoTransport]: 'plus',
  [ItinerarySegmentType.StenaUpsellNoTransport]: 'plus',
  [ItinerarySegmentType.Upsell]: 'activity',
  [ItinerarySegmentType.DateLocation]: 'locationMark',
};
</script>

<template>
  <div class="itinerary-icon">
    <AppSvgIcon
      :name="iconName[props.segmentType]"
      color="color-white"
      :size="iconSize"
    />
  </div>
</template>

<style scoped lang="scss">
.itinerary-icon {
  background-color: var(--color-neutral-70);
  border-radius: var(--border-radius-8);
  padding: var(--spacing-4);

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
